<script setup>
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import { Notification, NotificationGroup } from 'notiwind';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const breakpoints = useBreakpoints(breakpointsTailwind);

const maxNotifications = computed(() => (breakpoints.isSmallerOrEqual('md') ? 1 : 3));
</script>
<template>
    <NotificationGroup>
        <div
            class="pointer-events-none fixed inset-0 z-50 flex flex-col items-start justify-end p-6 px-4 md:flex-row"
        >
            <div class="w-full max-w-sm">
                <Notification
                    v-slot="{ notifications, close }"
                    :max-notifications="maxNotifications"
                    enter="transform ease-out duration-300 transition"
                    enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                    enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-500"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                    move="transition duration-500"
                    move-delay="delay-300"
                >
                    <div
                        v-for="notification in notifications"
                        :key="notification.id"
                        class="mx-auto mt-4 flex w-full max-w-sm overflow-hidden rounded-lg bg-white p-4 shadow-md"
                        @click="close(notification.id)"
                    >
                        <div class="flex w-8 justify-center py-1">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                            >
                                <g
                                    id="Group_865"
                                    data-name="Group 865"
                                    transform="translate(-832 -464)"
                                >
                                    <g
                                        id="Ellipse_39"
                                        data-name="Ellipse 39"
                                        transform="translate(832 464)"
                                        fill="#1ac73b"
                                        stroke="#1ac73b"
                                        stroke-width="1"
                                    >
                                        <circle
                                            cx="8"
                                            cy="8"
                                            r="8"
                                            stroke="none"
                                        />
                                        <circle
                                            cx="8"
                                            cy="8"
                                            r="7.5"
                                            fill="none"
                                        />
                                    </g>
                                    <path
                                        id="done_FILL0_wght400_GRAD0_opsz48_3_"
                                        data-name="done_FILL0_wght400_GRAD0_opsz48 (3)"
                                        d="M10.509,18.095,7.7,15.285l.539-.539,2.27,2.27L15.326,12.2l.539.539Z"
                                        transform="translate(828.383 456.903)"
                                        fill="#fff"
                                    />
                                </g>
                            </svg>
                        </div>

                        <div class="text-black">
                            <span class="font-bold">{{ t(notification.title) }}</span>
                            <p class="">
                                {{ t(notification.text) }}
                            </p>
                        </div>
                    </div>
                </Notification>
            </div>
        </div>
    </NotificationGroup>
</template>
